import { call, put, all, takeLatest } from 'redux-saga/effects';
import { IAddCredit, ICreateWorkProfile, IGetTalentReviews, IUpdateWorkProfile, types } from './types';
import {
    createTalentProfileSuccess,
    createTalentProfileFail,
    deleteTalentProfileFail,
    deleteTalentProfileSuccess,
    getAllTalentProfileFail,
    getAllTalentProfileSuccess,
    getCurrentUserTalentProfileSuccess,
    getCurrentUserTalentProfileFail,
    getTalentProfileDetailsFail,
    getTalentProfileDetailsSuccess,
    publishTalentProfileSuccess,
    publishTalentProfileFail,
    unPublishTalentProfileFail,
    unPublishTalentProfileSuccess,
    updateTalentProfileSuccess,
    updateTalentProfileFail,
    deleteSingleImageFromGallerySuccess,
    deleteSingleImageFromGalleryFail,
    deleteSingleImageSuccess,
    deleteSingleImageFail,
    uploadImageSuccess,
    uploadImageFail,
    // getTalentPastWorkSuccess,
    // getTalentPastWorkFail,
    getDiscoverSuccess,
    getDiscoverFail,
    getMyActsSuccess,
    getMyActsFail,
    getSingleActSuccess,
    getSingleActFail,
    getActsSuccess,
    getActsFail,
    createActSuccess,
    createActFail,
    deleteActSuccess,
    deleteActFail,
    getTalentReviewsSuccess,
    getTalentReviewsFail,
    getTalentReviews as getTalentReviewsAction,
    updateTalentProfile as updateTalentProfileAction,
    createTalentReview,
    createTalentReviewSuccess,
    createTalentReviewFail,
    updateTalentReview,
    updateTalentReviewSuccess,
    updateTalentReviewFail,
    deleteTalentReview,
    deleteTalentReviewSuccess,
    deleteTalentReviewFail,
    likeTalentReview,
    likeTalentReviewSuccess,
    likeTalentReviewFail,
    dislikeTalentReview,
    dislikeTalentReviewSuccess,
    dislikeTalentReviewFail,
    addCreditSuccess,
    addCreditFail,
    updateCreditSuccess,
    updateCreditFail,
    deleteCreditSuccess,
    deleteCreditFail,
} from './action';
import { globalErrorHandler } from '../error/saga';
import { api } from '../../configurations/api';
import {
    filterTalentUrl,
    talentReviewBaseUrl,
    getMyTalentProfileurl,
    talentProfileBaseUrl,
    deleteTalentSingleImageUrl,
    uploadTalentImagesUrl,
    discoverUrl,
    myActsUrl,
    actsUrl,
    pastWorkUrl,
} from '../../configurations/api/url';
import { httpRequest } from '../types';
import { SentryCapture } from '../../analytics/Sentry';
import { getNotUniqueCacheByKey, isUseCacheEnabled } from '../cache/saga';
import { CACHE_TYPE, NotUniqueCacheValue } from '../cache/types';
import { setCache } from '../cache/action';
import { isEmpty } from '../../utils/lodash';
import { showToastMessage } from '../../utils/AppUtils';
import { uploadFilesSaga } from '../upload/saga';
import { IGenericDocumentModifier } from '../../types/global/helper';
import { AxiosResponse } from 'axios';
import { addCacheQueryParam } from '../../utils/cacheHandler';

function* createCredit({ payload }: { payload: IAddCredit }): Generator<any, void, any> {
    try {
        const response = yield call(
            api,
            `${talentProfileBaseUrl}/${payload.profileId}/pastwork`,
            httpRequest.POST,
            payload,
        );
        const { data } = response.data;
        yield put(addCreditSuccess(data));
        yield call(showToastMessage, 'Credit added successfully', 'success');
    } catch (error: any) {
        yield put(addCreditFail(error));
        yield call(globalErrorHandler, error);
        SentryCapture(error);
    }
}

function* updateCredit({ payload }: { payload: IGenericDocumentModifier }): Generator<any, void, any> {
    try {
        const response = yield call(api, `${pastWorkUrl}/${payload.documentId}`, httpRequest.PATCH, payload.payload);
        const { data } = response.data;
        yield put(updateCreditSuccess(data));
        yield call(showToastMessage, 'Credit updated successfully', 'success');
    } catch (error: any) {
        yield put(updateCreditFail(error));
        yield call(globalErrorHandler, error);
        SentryCapture(error);
    }
}

function* deleteCredit({ payload }: { payload: IGenericDocumentModifier }): Generator<any, void, any> {
    try {
        yield call(api, `${pastWorkUrl}/${payload.documentId}`, httpRequest.DELETE, {});
        yield put(deleteCreditSuccess(payload));
        yield call(showToastMessage, 'Credit deleted successfully', 'success');
    } catch (error: any) {
        yield put(deleteCreditFail(error));
        yield call(globalErrorHandler, error);
        SentryCapture(error);
    }
}

function* filterTalent({ payload, resolve, reject }: any): any {
    try {
        const response = yield call(api, filterTalentUrl, httpRequest.POST, payload, 0, 0);
        const { data } = response.data;
        yield put(getAllTalentProfileSuccess(data));
        resolve(data);
    } catch (error) {
        SentryCapture(error, 'error');
        reject(error);
        yield put(getAllTalentProfileFail(error));
    }
}

// function* getCurrentTalentSelectionBioInformation(payload: string): any {
//     const requestUrl = `${biographyUrl}/${payload}`;
//     try {
//         const response = yield call(api, requestUrl, httpRequest.GET, null, 0, 0);
//         const { data } = response.data;
//         yield put(getTalentPastWorkSuccess(data));
//     } catch (error) {
//         SentryCapture(error, 'error');
//         yield put(getTalentPastWorkFail(error));
//     }
// }

function* getCurrentTalentProfile({ resolve, reject }: any): any {
    try {
        const response = yield call(api, getMyTalentProfileurl, httpRequest.GET, null, 0, 0);
        const { data } = response.data;
        yield put(getCurrentUserTalentProfileSuccess(data));
        if (data && !isEmpty(data))
            yield put(
                getTalentReviewsAction({
                    talentId: data[0]._id,
                }),
            );
        if (resolve) resolve(data);
    } catch (error: any) {
        SentryCapture(error, 'error');
        yield put(getCurrentUserTalentProfileFail(error));
        if (reject) reject(error);
    }
}

function* getTalentReviews({
    payload,
    resolve,
    reject,
}: {
    payload: IGetTalentReviews;
    resolve: (value: any) => Promise<void>;
    reject: (reason: any) => Promise<void>;
}): Generator<any, any, any> {
    const queryParams = new URLSearchParams();
    if (payload.limit) queryParams.append('limit', String(payload.limit));
    if (payload.page) queryParams.append('page', String(payload.page));
    const query = `?talent=${payload.talentId}&${queryParams.toString()}`;
    let initialResult: any = null;

    const defaultUseCache = yield* isUseCacheEnabled();
    const cache: NotUniqueCacheValue = yield* getNotUniqueCacheByKey(CACHE_TYPE.TALENT_REVIEW, query);

    if (cache && cache.key) {
        initialResult = cache.value;
    }

    if (defaultUseCache && initialResult) {
        yield put(getTalentReviewsSuccess(initialResult));
        if (resolve) resolve(initialResult);
    } else {
        try {
            const request = `${talentReviewBaseUrl}${query}`;
            const response = yield call(api, request, httpRequest.GET, {});
            yield put(getTalentReviewsSuccess(response));
            yield put(
                setCache({
                    key: query,
                    value: response,
                    type: CACHE_TYPE.TALENT_REVIEW,
                    isUnique: false,
                }),
            );
            if (resolve) resolve(response);
        } catch (error: any) {
            yield put(getTalentReviewsFail(error));
            if (reject) reject(error);
        }
    }
}

/** The below can also be used for search by conc ?title=arg&age= ...etc */
function* getAllTalentProfile({ payload, resolve, reject }: any): any {
    const { url } = payload || {};
    try {
        const request = `${talentProfileBaseUrl}/${url || ''}`;
        const response = yield call(api, request, httpRequest.GET, null, 0, 0);
        const { data } = response.data;
        yield put(getAllTalentProfileSuccess(data));
        resolve(data);
    } catch (error: any) {
        SentryCapture(error, 'error');
        yield put(getAllTalentProfileFail(error));
        reject(error);
    }
}

function* getTalentProfileDetail({ payload, resolve, reject }: any): any {
    try {
        const request = `${talentProfileBaseUrl}/wp/${payload}`;
        const response = yield call(api, request, httpRequest.GET, null, 0, 0);
        const { profiles } = response.data;
        yield put(getTalentProfileDetailsSuccess(profiles));
        if (resolve) resolve(profiles);
    } catch (error: any) {
        SentryCapture(error, 'error');
        yield put(getTalentProfileDetailsFail(error));
        if (reject) reject(error);
    }
}

function* deleteTalentProfile({ payload, resolve, reject }: any): any {
    try {
        const request = `${talentProfileBaseUrl}/${payload}`;
        const response = yield call(api, request, httpRequest.DELETE, null, 0, 0);
        const { data } = response.data;
        yield put(deleteTalentProfileSuccess(data));
        resolve(data);
    } catch (error: any) {
        SentryCapture(error, 'error');
        yield put(deleteTalentProfileFail(error));
        reject(error);
    }
}

function* createTalentProfile({ payload }: { payload: ICreateWorkProfile }): any {
    const { body, uploads } = payload;
    try {
        const response = yield call(api, talentProfileBaseUrl, httpRequest.POST, body, 0, 0);
        const { data } = response.data;
        let uploadedPhotosUrl;
        let profilePictureUrl;
        const uploadPayload: any = {};

        if (uploads.photos) {
            uploadedPhotosUrl = yield call(uploadFilesSaga, {
                payload: {
                    collection: 'profiles',
                    directory: 'media',
                    path: 'photos',
                    files: uploads.photos,
                    id: data._id,
                },
            });
            uploadPayload.photos = uploadedPhotosUrl;
        }

        if (uploads.profile_picture) {
            profilePictureUrl = yield call(uploadFilesSaga, {
                payload: {
                    collection: 'profiles',
                    directory: 'media',
                    path: 'profile_picture',
                    files: uploads.profile_picture,
                    id: data._id,
                },
            });
            uploadPayload.profile_picture = profilePictureUrl[0];
        }

        yield put(
            updateTalentProfileAction({
                id: data._id,
                body: {
                    ...uploadPayload,
                },
                fromCreate: true,
            }),
        );
    } catch (error: any) {
        SentryCapture(error, 'error');
        yield call(globalErrorHandler, error);
        yield put(createTalentProfileFail(error));
    }
}

function* updateTalentProfile({
    payload,
    resolve,
    reject,
}: {
    payload: IUpdateWorkProfile;
    resolve: (data: any) => Promise<void>;
    reject: (reason: any) => Promise<void>;
}): any {
    try {
        const { id, fromCreate, body } = payload;
        let unparsedUplaod: any = body;
        if (!fromCreate) {
            const { body, uploads } = payload;
            unparsedUplaod = body;
            let uploadedPhotosUrl;
            let profilePictureUrl;
            let featurePictureUrl;
            if (uploads && uploads.photos) {
                uploadedPhotosUrl = yield call(uploadFilesSaga, {
                    payload: {
                        collection: 'profiles',
                        directory: 'media',
                        path: 'photos',
                        files: uploads.photos,
                        id: id,
                    },
                });
                unparsedUplaod.photos = [
                    ...unparsedUplaod.photos.filter((photo: string) => photo.startsWith('https')),
                    ...uploadedPhotosUrl,
                ];
            }

            if (uploads && uploads.profile_picture) {
                profilePictureUrl = yield call(uploadFilesSaga, {
                    payload: {
                        collection: 'profiles',
                        directory: 'media',
                        path: 'photos',
                        files: uploads.profile_picture,
                        id: id,
                    },
                });
                unparsedUplaod.profile_picture = profilePictureUrl[0];
            }

            if (uploads && uploads.feature_picture) {
                featurePictureUrl = yield call(uploadFilesSaga, {
                    payload: {
                        collection: 'profiles',
                        directory: 'media',
                        path: 'photos',
                        files: uploads.feature_picture,
                        id: id,
                    },
                });
                unparsedUplaod = {
                    ...unparsedUplaod,
                    feature_picture: featurePictureUrl[0],
                };
            }
        }
        const request = `${talentProfileBaseUrl}/${id}`;
        const response = yield call(api, request, httpRequest.PATCH, unparsedUplaod, 0, 0);
        const { data } = response.data;
        if (fromCreate) {
            yield put(createTalentProfileSuccess(data));
            yield call(showToastMessage, 'Profile created successfully', 'success');
        } else {
            yield put(updateTalentProfileSuccess(data));
            yield call(showToastMessage, 'Profile updated successfully', 'success');
        }
        if (resolve) resolve(data);
    } catch (error: any) {
        SentryCapture(error, 'error');
        yield call(globalErrorHandler, error);
        yield put(updateTalentProfileFail({ ...error, additionalPayload: payload }));
        if (reject) reject(error);
    }
}

function* publishProfile({ payload }: { payload: IGenericDocumentModifier }): any {
    const request = `${talentProfileBaseUrl}/publish/${payload.documentId}`;
    try {
        const response = yield call(api, request, httpRequest.PATCH, {}, 0, 0);
        const { data } = response.data;
        yield put(publishTalentProfileSuccess(data));
    } catch (error: any) {
        SentryCapture(error, 'error');
        yield call(globalErrorHandler, error);
        yield put(publishTalentProfileFail(error));
    }
}

function* unPublishProfile({ payload }: { payload: IGenericDocumentModifier }): any {
    const request = `${talentProfileBaseUrl}/unpublish/${payload}`;
    try {
        const response = yield call(api, request, httpRequest.PATCH, {}, 0, 0);
        const { data } = response.data;
        yield put(unPublishTalentProfileSuccess(data));
    } catch (error: any) {
        SentryCapture(error, 'error');
        yield call(globalErrorHandler, error);
        yield put(unPublishTalentProfileFail(error));
    }
}

function* deleteSingleImage({ payload, resolve, reject }: any): any {
    const { id, body } = payload;
    const request = `${deleteTalentSingleImageUrl}/${id}`;

    try {
        const response = yield call(api, request, httpRequest.PATCH, body, 0, 0);
        const { data } = response.data;
        yield put(deleteSingleImageSuccess(data));
        resolve(data);
    } catch (error: any) {
        SentryCapture(error, 'error');
        yield call(globalErrorHandler, error);
        reject(error);
        yield put(deleteSingleImageFail(error));
    }
}

/** Specifically for deleting images from gallery */
function* deleteSingleImageFromGallery({ payload, resolve, reject }: any): any {
    const { id, body } = payload;
    const request = `${uploadTalentImagesUrl}/${id}`;
    try {
        const response = yield call(api, request, httpRequest.DELETE, body, 0, 0);
        const { data } = response.data;
        yield put(deleteSingleImageFromGallerySuccess(data));
        resolve(data);
    } catch (error: any) {
        SentryCapture(error, 'error');
        yield call(globalErrorHandler, error);
        reject(error);
        yield put(deleteSingleImageFromGalleryFail(error));
    }
}

function* uploadSingleImageToGallery({ payload, resolve, reject }: any): any {
    const { id, body, isImageUpload } = payload;
    const request = `${uploadTalentImagesUrl}/${id}`;
    try {
        const response = yield call(api, request, httpRequest.PATCH, body, 0, 0, isImageUpload);
        const { data } = response.data;
        yield put(uploadImageSuccess(data));
        resolve(data);
    } catch (error: any) {
        SentryCapture(error, 'error');
        yield call(globalErrorHandler, error);
        reject(error);
        yield put(uploadImageFail(error));
    }
}

function* getDiscoverWorker({ payload }: any): any {
    const discoverPayload = payload ? payload : { age_from: 1, age_to: 100, lng: 0, lat: 0, radius: 0 };
    try {
        const response = yield call(api, discoverUrl, httpRequest.POST, discoverPayload, 0, 0);
        const { data } = response;
        yield put(getDiscoverSuccess(data));
    } catch (error: any) {
        SentryCapture(error, 'error');
        yield call(globalErrorHandler, error);
        yield put(getDiscoverFail(error));
    }
}

function* getMyActsWorker(): any {
    try {
        const response = yield call(api, myActsUrl, httpRequest.GET, null, 0, 0);
        const { data } = response;
        yield put(getMyActsSuccess(data));
    } catch (error: any) {
        SentryCapture(error, 'error');
        yield call(globalErrorHandler, error);
        yield put(getMyActsFail(error));
    }
}

function* getSingleAct({ payload }: any): any {
    const request = `${actsUrl}/${payload}`;
    try {
        const response = yield call(api, request, httpRequest.GET, null, 0, 0);
        const { data } = response;
        yield put(getSingleActSuccess(data));
    } catch (error: any) {
        SentryCapture(error, 'error');
        yield call(globalErrorHandler, error);
        yield put(getSingleActFail(error));
    }
}

function* getAllActs(): any {
    try {
        const response = yield call(api, actsUrl, httpRequest.GET, null, 0, 0);
        const { data } = response;
        yield put(getActsSuccess(data));
    } catch (error: any) {
        SentryCapture(error, 'error');
        yield call(globalErrorHandler, error);
        yield put(getActsFail(error));
    }
}

function* createAct({ payload }: any): any {
    try {
        const response = yield call(api, actsUrl, httpRequest.POST, payload, 0, 0);
        const { data } = response;
        yield put(createActSuccess(data));
    } catch (error: any) {
        SentryCapture(error, 'error');
        yield call(globalErrorHandler, error);
        yield put(createActFail(error));
    }
}

function* deleteAct({ payload }: any): any {
    try {
        yield call(api, `${actsUrl}/${payload}`, httpRequest.DELETE, payload, 0, 0);
        yield put(deleteActSuccess(payload));
    } catch (error: any) {
        SentryCapture(error, 'error');
        yield call(globalErrorHandler, error);
        yield put(deleteActFail(error));
    }
}

function* createTalentReviewSaga(action: ReturnType<typeof createTalentReview>): Generator<any, void, any> {
    const url = addCacheQueryParam(talentReviewBaseUrl, action.payload.cache);
    try {
        const response: AxiosResponse = yield call(api, url, httpRequest.POST, action.payload, 0, 0);
        yield put(createTalentReviewSuccess(response.data.data));
        yield call(showToastMessage, 'Review successfull', 'success');
    } catch (error: any) {
        yield put(createTalentReviewFail(error));
        yield call(globalErrorHandler, error);
        SentryCapture(error);
    }
}

function* updateTalentReviewSaga(action: ReturnType<typeof updateTalentReview>): Generator<any, void, any> {
    try {
        const { id, ...data } = action.payload;
        const url = addCacheQueryParam(`${talentReviewBaseUrl}/${id}`, action.payload.cache);
        const response: AxiosResponse = yield call(api, url, httpRequest.PATCH, data, 0, 0);
        yield put(updateTalentReviewSuccess(response.data.data));
        yield call(showToastMessage, 'Review updated successfully', 'success');
    } catch (error: any) {
        yield put(updateTalentReviewFail(error));
        yield call(globalErrorHandler, error);
        SentryCapture(error);
    }
}

function* deleteTalentReviewSaga(action: ReturnType<typeof deleteTalentReview>): Generator<any, void, any> {
    try {
        yield call(api, `${talentReviewBaseUrl}/${action.payload}`, httpRequest.DELETE, {}, 0, 0);
        yield put(deleteTalentReviewSuccess(action.payload));
        yield call(showToastMessage, 'Review deleted successfully', 'success');
    } catch (error: any) {
        yield put(deleteTalentReviewFail(error));
        yield call(globalErrorHandler, error);
        SentryCapture(error);
    }
}

function* likeTalentReviewSaga(action: ReturnType<typeof likeTalentReview>): Generator<any, void, any> {
    try {
        const response: AxiosResponse = yield call(
            api,
            `${talentReviewBaseUrl}/${action.payload.reviewId}/like`,
            httpRequest.POST,
            { like_category: 'talentReview', like_type: 'like' },
            0,
            0,
        );
        yield put(likeTalentReviewSuccess(response.data.data));
    } catch (error: any) {
        yield put(likeTalentReviewFail(error));
        yield call(globalErrorHandler, error);
        SentryCapture(error);
    }
}

function* dislikeTalentReviewSaga(action: ReturnType<typeof dislikeTalentReview>): Generator<any, void, any> {
    try {
        const response: AxiosResponse = yield call(
            api,
            `${talentReviewBaseUrl}/${action.payload.reviewId}/like`,
            httpRequest.POST,
            { like_category: 'talentReview', like_type: 'dislike' },
            0,
            0,
        );
        yield put(dislikeTalentReviewSuccess(response.data.data));
    } catch (error: any) {
        yield put(dislikeTalentReviewFail(error));
        yield call(globalErrorHandler, error);
        SentryCapture(error);
    }
}

/********** WATCHERS *************************** */

function* getTalentReviewsWatcher() {
    yield takeLatest<any>(types.GET_TALENT_REVIEWS, getTalentReviews);
}

function* createTalentProfileWatcher() {
    yield takeLatest<any>(types.CREATE_TALENT_PROFILE, createTalentProfile);
}

function* updateTalentProfileWatcher() {
    yield takeLatest<any>(types.UPDATE_TALENT_PROFILE, updateTalentProfile);
}

function* publishTalentProfileWatcher() {
    yield takeLatest<any>(types.PUBLISH_TALENT_PROFILE, publishProfile);
}

function* unPublishTalentProfileWatcher() {
    yield takeLatest<any>(types.UNPUBLISH_TALENT_PROFILE, unPublishProfile);
}

function* deleteSingleImageWatcher() {
    yield takeLatest(types.DELETE_SINGLE_TALENT_IMAGE, deleteSingleImage);
}

function* deleteSingleImageFromGalleryWatcher() {
    yield takeLatest(types.DELETE_SINGLE_IMAGE_FROM_TALENT__GALLERY, deleteSingleImageFromGallery);
}

function* uploadSingleImageToGalleryWatcher() {
    yield takeLatest(types.UPLOAD_IMAGE, uploadSingleImageToGallery);
}

function* getCurrentTalentProfileWatcher() {
    yield takeLatest(types.GET_CURRENT_USER_TALENT_PROFILE, getCurrentTalentProfile);
}

function* getAllTalentProfileWatcher() {
    yield takeLatest(types.GET_ALL_TALENT_PROFILES, getAllTalentProfile);
}

function* getTalentProfileDetailWatcher() {
    yield takeLatest(types.GET_TALENT_PROFILE_DETAILS, getTalentProfileDetail);
}

function* deleteTalentProfileWatcher() {
    yield takeLatest(types.DELETE_TALENT_PROFILE, deleteTalentProfile);
}

function* filterTalentWatcher() {
    yield takeLatest(types.FILTER_TALENT, filterTalent);
}

function* getDiscoverWatcher() {
    yield takeLatest(types.GET_DISCOVER, getDiscoverWorker);
}

function* getMyActsWatcher() {
    yield takeLatest(types.GET_MY_ACTS, getMyActsWorker);
}

function* getSingleActWatcher() {
    yield takeLatest(types.GET_SINGLE_ACT, getSingleAct);
}

function* getAllActsWacher() {
    yield takeLatest(types.GET_ACTS, getAllActs);
}

function* createActWatcher() {
    yield takeLatest(types.CREATE_ACT, createAct);
}

function* deleteActWatcher() {
    yield takeLatest(types.DELETE_ACT, deleteAct);
}

function* createTalentReviewWatcher() {
    yield takeLatest(types.CREATE_TALENT_REVIEW, createTalentReviewSaga);
}

function* updateTalentReviewWatcher() {
    yield takeLatest(types.UPDATE_TALENT_REVIEW, updateTalentReviewSaga);
}

function* deleteTalentReviewWatcher() {
    yield takeLatest(types.DELETE_TALENT_REVIEW, deleteTalentReviewSaga);
}

function* likeTalentReviewWatcher() {
    yield takeLatest(types.LIKE_TALENT_REVIEW, likeTalentReviewSaga);
}

function* dislikeTalentReviewWatcher() {
    yield takeLatest(types.DISLIKE_TALENT_REVIEW, dislikeTalentReviewSaga);
}

function* addCreditWatcher() {
    yield takeLatest<any>(types.ADD_CREDIT, createCredit);
}

function* updateCreditWatcher() {
    yield takeLatest<any>(types.UPDATE_CREDIT, updateCredit);
}

function* deleteCreditWatcher() {
    yield takeLatest<any>(types.DELETE_CREDIT, deleteCredit);
}

export default function* talentProfileSaga() {
    yield all([
        createTalentProfileWatcher(),
        updateTalentProfileWatcher(),
        publishTalentProfileWatcher(),
        unPublishTalentProfileWatcher(),
        deleteSingleImageWatcher(),
        deleteSingleImageFromGalleryWatcher(),
        uploadSingleImageToGalleryWatcher(),
        getCurrentTalentProfileWatcher(),
        getAllTalentProfileWatcher(),
        getTalentProfileDetailWatcher(),
        deleteTalentProfileWatcher(),
        filterTalentWatcher(),
        getDiscoverWatcher(),
        getMyActsWatcher(),
        getSingleActWatcher(),
        getAllActsWacher(),
        createActWatcher(),
        deleteActWatcher(),
        getTalentReviewsWatcher(),
        createTalentReviewWatcher(),
        updateTalentReviewWatcher(),
        deleteTalentReviewWatcher(),
        likeTalentReviewWatcher(),
        dislikeTalentReviewWatcher(),
        addCreditWatcher(),
        updateCreditWatcher(),
        deleteCreditWatcher(),
    ]);
}
